<template>
	<section class="Entry" :class="{ bot: isFromBot, reversed, 'no-delay': noDelay, current }" :style="{ '--delay': delay }">
		<div class="container">
			<div class="avatar" v-if="hasThumb">
				<Thumb :thumb="isFromBot ? null : data.thumb || `${root + (root.endsWith('/') ? '' : '/')}images/default_user.jpg`" />
			</div>
			<transition name="pop">
				<div v-if="isTyping" class="typing">
					<span></span>
					<span></span>
					<span></span>
				</div>
				<section v-else class="message">
					<div
						v-for="(content, id) in contents"
						:key="`content_${id}`"
						class="content"
						:class="{ app: !!content.app }"
						:data-app="content.app || content.style || content.rt"
					>
						<span class="image" v-if="'image' === (content.style || content.rt)">
							<img v-for="(img, id) in getImages(content.meta)" :key="`image_${id}`" :src="img.image" />
						</span>
						<Calendar v-else-if="content.app === 'calendar'" v-bind="content" @select="onSelectDate" />
						<Radio v-else-if="['radio', 'checkbox'].includes(content.app)" v-bind="content" @select="onSelectRadio" />
						<Segments v-else-if="content.app === 'segments'" v-bind="content" @select="onSelectSegment" />
						<Email v-else-if="content.app === 'email'" v-bind="content" @send="onSendEmail" />
						<Search v-else-if="content.app === 'search'" v-bind="content" @search="onSearch" />
						<Upload v-else-if="['upload', 'file'].includes(content.app)" v-bind="content" @upload="onUpload" />
						<Address v-else-if="content.app === 'address'" v-bind="content" @send="onSendAddress" />
						<Payment v-else-if="content.app === 'payment'" v-bind="content" @pay="onPay" />
						<ImageMap v-else-if="content.app === 'imagemap'" v-bind="content" @select="onTapImageButton" />
						<Carousel v-else-if="content.app === 'carousel'" v-bind="content" @select="onTapCarousel" />
						<ImageCarousel v-else-if="content.app === 'imagecard'" v-bind="content" @select="onSelectButton" />
						<InputField v-else-if="content.app === 'input'" v-bind="content" @submit="onInputSubmit" />
						<Miniapp v-else-if="content.app === 'miniapp'" v-bind="content" @submit="onMiniappSubmit" />
						<span class="text" v-else-if="content.msg !== undefined">{{ processMessage(content.msg) }}</span>
						<Unsupported v-else v-bind="content" />

						<div class="options" v-if="hasActions(content)" ref="bigButtons">
							<A class="option" v-for="option in content.items" :key="`option_${option.id}`" @click="onSelectButton(option)">{{
								option.label
							}}</A>
						</div>
					</div>
					<div class="time" v-if="showtime">{{ time }}</div>
					<div class="attachments" v-if="hasButtons()" ref="smallButtons">
						<Buttons v-if="data.btns && data.btns.length > 0" :data="data.btns" @select="onSelectButton" />
					</div>
					<div class="attachments" v-if="hasFiles()">
						<Upload :data="data.fhs && data.fhs[0]" @upload="onUpload" />
					</div>
				</section>
			</transition>
		</div>
	</section>
</template>

<script>
	import { getTimeText } from '../libs/utils';
	import { mapState } from 'vuex';
	import Thumb from './Thumb';

	import Buttons from './attachments/Buttons';
	import Calendar from './attachments/Calendar';
	import Radio from './attachments/Radio';
	import Segments from './attachments/Segments';
	import Email from './attachments/Email';
	import Search from './attachments/Search';
	import Upload from './attachments/Upload';
	import Address from './attachments/Address';
	import Payment from './attachments/Payment';
	import ImageMap from './attachments/ImageMap';
	import Carousel from './attachments/Carousel';
	import ImageCarousel from './attachments/ImageCarousel';
	import Unsupported from './attachments/Unsupported';
	import Miniapp from './attachments/Miniapp';
	import InputField from './attachments/InputField';

	import { logX } from '../common/libs/utils';
	import { processText, saveVariable } from '../services/userVariables';
	import store from '../store';
	import http from '../services/http';

	export default {
		props: ['data', 'showtime', 'delay', 'typing', 'current'],
		data() {
			return {
				isTyping: false,
				fetched: false,
				fetchedData: {}
			};
		},
		components: {
			Thumb,
			Buttons,
			Calendar,
			Radio,
			Segments,
			Email,
			Search,
			Upload,
			Address,
			Payment,
			ImageMap,
			Carousel,
			ImageCarousel,
			Unsupported,
			Miniapp,
			InputField
		},
		methods: {
			onSelectButton(button) {
				this.$emit('reply', {
					text: button.label,
					data: button,
					type: button.type || 'button'
				});
				document.activeElement.blur();
			},
			getImages(data) {
				return this.parseJSON(data);
			},
			hasActions(content) {
				return content.items && content.items.length > 0 && !['imagemap', 'card', 'imagecard'].includes(this.data.rt);
			},
			hasButtons() {
				let hasBtns =
					this.data.btns &&
					this.data.btns.length > 0 &&
					(this.data.rt !== 'imagemap' || this.data.btns.filter(btn => !btn.area).length > 0);
				return hasBtns;
			},
			hasFiles() {
				const result = this.data.fhs?.length > 0;
				console.log(result);
				return result;
				// return content.items && content.items.length > 0 && !['imagemap', 'card', 'imagecard'].includes(this.data.rt);
			},

			onSelectDate([date, time]) {
				this.$emit('reply', {
					text:
						date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }) +
						(time
							? ' ' +
							  (Array.isArray(time) ? time : [time])
									.sort((a, b) => b - a)
									.map(i => `${(i + '').padStart(2, 0)}:00~${(i + 1 + '').padStart(2, 0)}:00`)
									.join(', ')
							: ''),
					data: this.data?.items?.[0] || {},
					type: 'button'
				});
			},
			onSelectRadio(value) {
				this.$emit('reply', {
					text: Array.isArray(value) ? value.join(', ') : value,
					data: this.data?.data || {},
					type: 'button'
				});
			},
			onSelectSegment({ segment, option }) {
				this.$emit('reply', {
					text: `${segment} ${option}`,
					data: this.data?.items?.[0] || {},
					type: 'button'
				});
			},
			onSendEmail({ title, body }) {
				this.$emit('reply', {
					text: `「${title}: ${body}」`,
					data: this.data?.items?.[0] || {},
					type: 'button'
				});
			},
			onSearch(search) {
				this.$emit('reply', {
					text: search,
					data: this.data?.items?.[0] || {},
					type: 'button'
				});
			},
			onUpload(url) {
				const fs = this.data?.fhs?.[0];
				if (fs) {
					fs.url = url;
					this.$emit('reply', {
						text: url,
						data: fs,
						type: 'upload'
					});
				}
			},
			onSendAddress({ zip, addr1, addr2 }) {
				this.$emit('reply', {
					text: '〒' + zip + '\n' + addr1 + '\n' + addr2,
					data: this.data?.items?.[0] || {},
					type: 'button'
				});
			},
			onPay({ method, data }) {
				data = {
					...data,
					expires: data.expires.join('/'),
					number: data.number.join('')
				};
				saveVariable('$creditcard', data, this.data.data);
				this.$emit('reply', {
					text: data.number.replace(/.(?=.{4,}$)/g, '*'),
					data: this.data.data,
					type: 'button'
				});
			},
			onTapImageButton(button) {
				this.$emit('reply', {
					text: button.label,
					data: button,
					type: 'button'
				});
			},
			onTapCarousel(type, element) {
				if (type === 'card') {
					if (element.linkto) {
						window.open(element.linkto);
					}
				} else {
					this.$emit('reply', {
						text: element.label,
						data: element,
						type: element.type || 'button'
					});
				}
			},

			processMessage(text) {
				return processText(text);
			},

			onMiniappSubmit(data, item, button) {
				// TODO: miniapp
				this.logX('MINIAPP DATA', 'magenta', data, item, button);
				Object.entries(data).forEach(([k, v]) => {
					saveVariable(k, v, item);
				});

				this.$emit('reply', {
					text: button.title,
					data: item,
					type: 'button',
					source: 'miniapp'
				});
			},

			onInputSubmit(text) {
				this.$emit('reply', {
					text,
					data: this.data,
					source: 'input'
				});
			}
		},
		computed: {
			...mapState(['bot', 'reversed', 'readonly', 'noTyping']),
			time() {
				return getTimeText(this.data.ins_t);
			},
			isFromBot() {
				return this.data.fid !== 'user' || this.data.action;
			},

			hasThumb() {
				return this.isFromBot || this.readonly;
			},
			app() {
				const opts = this.data.opts || this.data.styles;
				if (opts) {
					try {
						const { app } = this.parseJSON(opts);
						return app;
					} catch (ex) {}
				}
				return undefined;
			},
			root() {
				return process.env.VUE_APP_ROOT_PATH;
			},
			noDelay() {
				return this.readonly;
			},
			contents() {
				if (this.data.hidden) return [];

				let data = [];
				if (this.data.before_msgs) {
					if (typeof this.data.before_msgs === 'string' && this.data.before_msgs.startsWith('["')) {
						this.parseJSON(this.data.before_msgs).forEach(msg => data.push({ msg }));
					} else if (Array.isArray(this.data.before_msgs)) {
						this.data.before_msgs.forEach(msg => data.push({ msg }));
					}
				}

				if (/^\[".*"\]$/[Symbol.match](this.data.msg)) {
					try {
						const msgs = this.parseJSON(this.data.msg);
						msgs.forEach((msg, i) => {
							if (i < msgs.length - 1) {
								data.push({ msg });
							} else {
								data.push({ ...this.data, msg });
							}
						});
					} catch (ex) {
						data = [...data, this.data];
					}
				} else {
					data = [...data, this.data];
				}

				if (this.data.type === 'calendar') {
					const { start, period, reserve_type } = this.parseJSON(this.data.data.timesetting);
					const { datetype: type = 'datetime' } = this.data.data;
					data = [...data, { app: 'calendar', start: start ? new Date(start) : new Date(), period, type }];
				} else if (['radio', 'checkbox'].includes(this.data.type)) {
					let options = [];
					if (this.data.data.uri) {
						let uri = `${window.location.protocol}//${window.location.host}` + processText(this.data.data.uri);
						if (typeof this.fetchedData[this.data.data.id] === 'undefined') {
							this.logX('FETCH API', 'orange', uri);
							http.get(uri).then(result => {
								this.logX('FETCH RESULT', 'orange', result);
								if (typeof result === 'string') {
									if (result.startsWith('[')) {
										result = this.parseJSON(result);
									} else {
										// result = result.split('\n');
										result = [];
									}
								} else if (!Array.isArray(result)) {
									result = [];
								}
								this.fetchedData = {
									...this.fetchedData,
									[this.data.data.id]: result
								};
							});
						} else {
							options = this.fetchedData[this.data.data.id];
						}
					} else if (this.data.data.val) {
						options = this.data.data.val.split('\n');
					}
					data = [...data, { app: 'radio', options, multiselect: this.data.data.type === 'checkbox' }];
				} else if (this.data.type === 'calendar') {
					const { start, period, reserve_type } = this.parseJSON(this.data.data.timesetting);
					const { datetype: type = 'datetime' } = this.data.data;
					data = [...data, { app: 'calendar', start: start ? new Date(start) : new Date(), period, type }];
				} else if (['radio', 'checkbox'].includes(this.data.type)) {
					let options = [];
					if (this.data.data.val) {
						options = this.data.data.val.split('\n');
					}
					data = [...data, { app: 'radio', options, multiselect: this.data.data.type === 'checkbox' }];
				} else if (this.data.rt === 'miniapp') {
					let d = data.pop();
					let miniapp = this.bot.views?.find(view => view.id == this.parseJSON(this.data.meta)?.vid);
					if (miniapp) {
						data = [...data, { ...d, app: 'miniapp', miniapp }];
					}
				} else if (['imagecard'].includes(this.data.rt)) {
					data.length = data.length - 1;
					const cards = this.parseJSON(this.data.meta)?.map((info, i) => {
						const button = this.data.items?.find(e => e.seq == i);
						if (button) {
							info.button = button;
						}
						return info;
					});
					data = [...data, { app: 'imagecard', cards }];
				} else if (['payment'].includes(this.data.type)) {
					let d = data.pop();
					data = [...data, { ...d, app: 'payment', methods: ['creditcard'] }];
				} else if (['text'].includes(this.data.rt) && this.data.ipts?.length) {
					let d = data.pop();
					// const { ipts, msg } = d;
					data = [...data, { ...d, app: 'input', action: this.data }];
				} else if ('imagemap' === this.data.rt) {
					data[data.length - 1] = { ...data[data.length - 1], app: 'imagemap' };
				} else if ('card' === this.data.rt) {
					data[data.length - 1] = { ...data[data.length - 1], app: 'carousel' };
				} else if (this.data.msg === '{$pay}') {
					data.length = data.length - 1;
					data.push({ app: 'payment' });
				}
				// else if (this.data.msg === '{$segments}') {
				// 	data.length = data.length - 1;
				// 	const button = '地域選択を確定する';
				// 	const segments = [
				// 		{
				// 			label: '東北',
				// 			children: [
				// 				{
				// 					label: '東北1',
				// 					value: '東北1'
				// 				},
				// 				{
				// 					label: '東北2',
				// 					value: '東北2'
				// 				},
				// 				{
				// 					label: '東北3',
				// 					value: '東北3'
				// 				}
				// 			]
				// 		},
				// 		{
				// 			label: '関東',
				// 			children: [
				// 				{
				// 					label: '埼玉',
				// 					value: '埼玉'
				// 				},
				// 				{
				// 					label: '東京',
				// 					value: '東京'
				// 				},
				// 				{
				// 					label: '神奈川',
				// 					value: '神奈川'
				// 				},
				// 				{
				// 					label: '千葉',
				// 					value: '千葉'
				// 				}
				// 			]
				// 		},
				// 		{
				// 			label: '近畿',
				// 			children: [
				// 				{
				// 					label: '近畿1',
				// 					value: '近畿1'
				// 				},
				// 				{
				// 					label: '近畿2',
				// 					value: '近畿2'
				// 				},
				// 				{
				// 					label: '近畿3',
				// 					value: '近畿3'
				// 				}
				// 			]
				// 		}
				// 	];
				// 	data.push({ app: 'segments', segments, button });
				// } else if (this.data.msg === '{$email}') {
				// 	data.length = data.length - 1;
				// 	data = [...data, { app: 'email' }];
				// } else if (this.data.msg === '{$search}') {
				// 	data.length = data.length - 1;
				// 	const search = {
				// 		entries: [
				// 			'保証書は商品購入時にもらえますか？',
				// 			'保証期間はどれくらいですか？',
				// 			'中古車にも保証は適用されますか？',
				// 			'Lorem ipsum',
				// 			'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
				// 			'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Accusamus, vel!',
				// 			'Lorem ipsum dolor sit amet consectetur1',
				// 			'Lorem ipsum dolor sit amet consectetur2',
				// 			'Lorem ipsum dolor sit amet consectetur3',
				// 			'Lorem ipsum dolor sit amet consectetur4',
				// 			'Lorem ipsum dolor sit amet consectetur5',
				// 			'Lorem ipsum dolor sit amet consectetur6'
				// 		]
				// 	};
				// 	data.push({ app: 'search', search });
				// } else if (this.data.msg === '{$upload}') {
				// 	data.length = data.length - 1;
				// 	data.push({ app: 'upload' });
				// } else if (this.data.msg === '{$address}') {
				// 	data.length = data.length - 1;
				// 	data.push({ app: 'address' });
				// }
				return data;
			}
		},
		beforeMount() {
			if (this.typing && !this.noTyping) {
				this.isTyping = true;
				setTimeout(() => {
					this.isTyping = false;
					setTimeout(() => {
						this.$emit('updated');
					}, 400);
				}, 750 + Math.random() * 1250);
			}
		},
		mounted() {
			this.$refs.smallButtons?.querySelector('.A')?.focus();
			this.$refs.bigButtons?.[0]?.children?.[0].focus();
		}
	};
</script>

<style scoped lang="scss">
	.Entry {
		&:not(.no-delay) {
			animation: right-to-left 0.2s cubic-bezier(0.06, 0.75, 0.6, 1.19) calc(var(--delay, 0) * 0.1s) both;
		}

		&:not(:first-child) {
			margin-top: 1rem;
		}

		.container {
			display: flex;
			align-items: flex-start;
			margin: -0.5rem;
			flex-direction: row-reverse;

			& > * {
				margin: 0.5rem;
			}

			.avatar {
				position: relative;
				width: 4rem;
				height: 4rem;
				border-radius: 4rem;
				flex: 0 0 4rem;
				overflow: hidden;

				img {
					object-fit: cover;
					object-position: center;
					width: 100%;
					height: 100%;
				}
			}

			.typing {
				display: flex;
				align-self: center;
				margin-left: 1rem;

				& > * {
					display: block;
					width: 1rem;
					height: 1rem;
					background-color: var(--clrTheme);
					animation: typing 0.5s ease-in-out infinite both;
					border-radius: 1rem;
					&:not(:first-child) {
						margin-left: 0.5rem;
					}

					@for $i from 1 through 6 {
						&:nth-child(#{$i}) {
							animation-delay: #{$i * -0.15}s;
						}
					}
				}
			}

			.message {
				max-width: calc(100% - 10rem);
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				position: relative;

				& > * {
					&:not(:first-child) {
						margin-top: 0.5rem;
					}
					max-width: 100%;
				}

				.time {
					opacity: 0.4;
					font-style: italic;
					font-size: 1.2rem;
					margin-left: 0.5rem;
					margin-right: 0.5rem;
					text-align: right;
				}

				.content {
					background-color: var(--clrTheme);
					color: white;
					border-radius: 1rem;
					// word-break: break-all;
					box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
					overflow: hidden;

					&[data-app='carousel'],
					&[data-app='imagecard'] {
						background-color: transparent !important;
						box-shadow: initial !important;
						border-radius: initial !important;
						margin: 0 -0.5rem !important;
					}

					/deep/ .Carousel {
						.cards {
							.card {
								&:first-of-type {
									margin-left: auto;
								}
							}
						}
					}

					.text {
						display: block;
						white-space: pre-wrap;
						word-break: break-word;
						// line-break: loose;

						padding: 1rem 1.6rem;
					}

					.image {
						img {
							max-width: 60vw;
						}
					}

					.options {
						border-top: solid 1px rgba(0, 0, 0, 0.1);

						.option {
							display: block;
							text-align: center;
							color: var(--clrTheme);
							padding: 1rem;
							outline: none;
							min-width: 16rem;
							&:hover,
							&:focus {
								background-color: var(--clrTheme);
								color: white;
							}
						}
					}
				}

				.attachments {
					/deep/ .Buttons {
						justify-content: flex-end;
					}
				}
			}
		}

		&.bot:not(.reversed),
		&.reversed:not(.bot) {
			animation-name: left-to-right;

			.container {
				flex-direction: row;

				.message {
					align-items: flex-start;

					.content {
						background-color: white;
						color: #57585a;
					}

					.time {
						text-align: left;
					}

					.attachments {
						/deep/ .Buttons {
							justify-content: flex-start;
						}
					}
				}
			}
		}
	}

	@keyframes typing {
		0% {
			transform: translateY(-0.2rem);
		}

		50% {
			transform: translateY(0.2rem);
		}

		100% {
			transform: translateY(-0.2rem);
		}
	}

	@keyframes left-to-right {
		from {
			opacity: 0;
			transform: translateX(-10rem);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes right-to-left {
		from {
			opacity: 0;
			transform: translateX(10rem);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}
</style>
